var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{attrs:{"title":"使用趨勢","title-link-class":_vm.tabClass}},[_c('div',{attrs:{"id":_vm.id}},[(_vm.debug)?_c('div',[_vm._v(_vm._s(_vm.keywords))]):_vm._e(),(_vm.error)?_c('h2',[_vm._v("無資料")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }